import {useQuery} from "@apollo/client";
import {useContext, useState} from "react";

import {FormOverlayButtons} from "@/components/form/overlay/FormOverlayButtons.tsx";
import {TabModalContainer} from "@/components/layout/TabModalContainer.tsx";
import {GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS} from "@/lib/queries/statuspages.ts";
import {SubscriptionEmailDomainResultCounts, SubscriptionEmailDomainType} from "@/lib/types/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {AllowBlockListTabContent} from "@/pages/statuspages/tabs/subscribers/components/allow-block-list/AllowBlockListTabContent.tsx";

export interface AllowBlockListModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

export const AllowBlockListModal = ({show, setShow}: AllowBlockListModalProps) => {
  const [activeTab, setActiveTab] = useState<SubscriptionEmailDomainType>(SubscriptionEmailDomainType.ALLOWED);
  const {statusPage} = useContext(StatusPageContext);
  const {data} = useQuery<SubscriptionEmailDomainResultCounts>(GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS, {
    variables: {
      statusPageID: statusPage.id,
    },
  });

  const sections = {
    [SubscriptionEmailDomainType.BLOCKED as string]: {
      id: SubscriptionEmailDomainType.BLOCKED,
      title: "Block List",
      isVisible: true,
      badgeText: data?.blocked.total.toString(),
    },
    [SubscriptionEmailDomainType.ALLOWED as string]: {
      id: SubscriptionEmailDomainType.ALLOWED,
      title: "Allow List",
      isVisible: true,
      badgeText: data?.allowed.total.toString(),
    },
  };
  return (
    <>
      {show && (
        <TabModalContainer
          onHide={() => setShow(false)}
          title={"Email Allow & Block List"}
          sections={sections}
          tab={activeTab}
          setTab={(tab) => setActiveTab(tab as SubscriptionEmailDomainType)}
          bottomActionsBar={
            <FormOverlayButtons hasSubmitButton={true} submitText="Close" onSubmit={() => setShow(false)} />
          }
        >
          <AllowBlockListTabContent domainType={activeTab} />
        </TabModalContainer>
      )}
    </>
  );
};
